/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { useDispatch } from "react-redux";
import { setAuthenticated, setUser } from "cms/store/reducers/auth-customer";
import { useMsal } from "@azure/msal-react";
import { CmsConfig } from "cms/config";
// import { msalConfig } from '../../authConfig'

/**
 * useCustomerAuth
 * Implements login and logout for customer authentication
 * @returns {{processing: boolean, login: ((function(): Promise<void>)|*), logout: ((function(): Promise<void>)|*)}}
 */
const useCustomerAuth = () => {
    const enableCustomerAuth = CmsConfig.enableCustomerAuth;

    const dispatch = useDispatch();
    const { instance } = useMsal();
    const [processing, setProcessing] = useState(false);

    /**
     * login
     *
     * @returns {Promise<void>}
     */
    const login = async () => {
        setProcessing(true);
        try {
            console.log(`Starting Login`);
            if (enableCustomerAuth) {
                await instance.loginRedirect({});
                dispatch(setAuthenticated(true));
                const account = await getAccount();
                dispatch(setUser(account));
            } else {
                // dispatch(setUser({guid: "mock-user"}))
                setTimeout(() => {
                    console.log(`Login Mocked.`);
                    dispatch(setAuthenticated(true));
                    setProcessing(false);
                }, 1000);
            }
        } catch (err) {
            // handle error
        }
    };

    /**
     * logout
     *
     * @returns {Promise<void>}
     */
    const logout = async () => {
        setProcessing(true);
        try {
            console.log(`Starting Logout`);
            if (enableCustomerAuth) {
                let account = await getAccount();
                if (account) {
                    // let homeAccountId = await getAccountId(account)
                    // const logoutRequest = {
                    //     account: instance.getAccountByHomeId(homeAccountId),
                    //     postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
                    // };
                    // await instance.logoutRedirect(logoutRequest);
                    await instance.logoutPopup();
                } else {
                    console.error("LOGOUT: no account");
                }
            }
            dispatch(setAuthenticated(false));
            dispatch(setUser(undefined));
            setProcessing(false);
        } catch (err) {
            console.error(err);
            setProcessing(false);
        }
    };

    const getAccount = async () => {
        try {
            const accounts = instance.getAllAccounts();
            // const account = instance.getActiveAccount();
            console.info(accounts[0]);
            let current;
            if (accounts.length > 0) {
                current = accounts[0];
            } else {
                console.error("Get Account: no account");
            }
            return current;
        } catch (err) {
            console.error(err);
        }

    };

    // const getAccountId = async (account) => {
    //     try {
    //         return account.homeAccountId;
    //     } catch (err) {
    //         console.error(err);
    //     }
    // };

    // const fakeLogin = () => {
    //     setProcessing(true)
    //     setTimeout(() => {
    //         setProcessing(false)
    //         dispatch(setAuthenticated(true))
    //     },1200)
    // }
    // const fakeLogout = () => {
    //     setProcessing(true)
    //     setTimeout(() => {
    //         setProcessing(false)
    //         dispatch(setAuthenticated(false))
    //     },600)
    // }

    return {
        processing,
        login,
        logout
    };
};

export { useCustomerAuth };
